<template>
  	<div id="coinAdaList">
  		<mt-header fixed :title="$t('选择币种')">
		  	<mt-button icon="back" slot="left" @click.native="$router.back()"></mt-button>
		</mt-header>
		<div ref="main_list" class="main_list">
            <ul class="content_detail main_show">
                <li v-for="(item,index) in CoinsList" style="position: relative;" :key="index">
                    <div @click="CoinName(item.id,item.coin_symbol)">
                        <span class="currency_name">
                            <span class="receive wx_fontSize3">{{item.coin_symbol}}</span>
                            <span class="form wx_fontSize2">{{item.coin_name}}</span>
                        </span>
                        <span class="balance wx_rt">{{item.cloud_balance  | numFilter}}</span>
                    </div>
                </li>
            </ul>
		</div>
  	</div>
</template>
<script>
import { httpRedEnvelopeCoins } from "@/api/index";
import { Toast } from "mint-ui";
import { numFilter } from "@/filters/index";
export default {
    data(){
        return{
            CoinsList:[],    
        }
    },
    activated(){
        this.coinList();
    },
    methods:{
        coinList(){
            httpRedEnvelopeCoins({})
            .then(res => {
                this.CoinsList = [];
                this.CoinsList = res.data.list;
            })
            .catch(() => {});
        },
        CoinName(id,name){ 
            this.name = {name:name,id:id};  
            this.$router.go(-1)
        }
    }, 
    beforeRouteLeave(to, from, next) {
        to.query.result = this.name;
        next();
    }
}
</script>

<style scoped>
#coinAdaList{position: relative;width:100%;height:100%;overflow-y: scroll;}
.mint-header{background: #fff;color:#212529;border-bottom: 1px solid #e3e8ed;}
.mint-button--default{color:#656b79 !important;}
.main_list{padding:40px 15px 0 15px;}
.main_show{width:100%;}
.childList{width:80%;margin-left: 20%;display:none;}
.content_detail li{width:100%;background:#fff;border-bottom:1px solid #e3e8ed;}
.currency_name{position: relative;width:70%;height:70px;display: inline-block;}
.receive{position: absolute;top:10px;}
.form{position: relative;top:35px;color:#8c92a8;}
.amount_of{width:20%;text-align: right;padding:5px 0;border:1px solid #1296db;text-align: center;margin-top: 17px;color:#1296db;}
.balance{width:30%;line-height: 70px;text-align: right;}
</style>